var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgZone = function SvgZone(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none",
    viewBox: "0 0 38 38",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#183E62",
    d: "M26.427 25.465a1.06 1.06 0 0 0-.776.208 1.04 1.04 0 0 0-.192 1.461c.17.219.421.362.697.398 6.563.857 9.51 2.635 9.51 3.668 0 1.447-5.728 4.133-16.666 4.133-10.937 0-16.667-2.686-16.667-4.133s5.375-3.947 15.625-4.133v3.1c0 .274.11.536.305.73a1.046 1.046 0 0 0 1.474 0 1.03 1.03 0 0 0 .305-.73V16.66a8.35 8.35 0 0 0 5.378-2.93 8.22 8.22 0 0 0 1.897-5.79 8.24 8.24 0 0 0-2.612-5.507A8.37 8.37 0 0 0 19 .193a8.37 8.37 0 0 0-5.705 2.24 8.24 8.24 0 0 0-2.612 5.508 8.22 8.22 0 0 0 1.897 5.79 8.35 8.35 0 0 0 5.378 2.93V25C8.99 25.155.25 27.273.25 31.2S9.677 37.4 19 37.4s18.75-2.129 18.75-6.2c0-3.823-7.917-5.28-11.323-5.735M12.75 8.467c0-1.227.367-2.425 1.053-3.445a6.24 6.24 0 0 1 2.805-2.283 6.3 6.3 0 0 1 3.611-.353c1.213.239 2.326.83 3.2 1.697a6.2 6.2 0 0 1 1.71 3.174 6.15 6.15 0 0 1-.355 3.582 6.2 6.2 0 0 1-2.302 2.783 6.286 6.286 0 0 1-7.891-.771 6.18 6.18 0 0 1-1.831-4.384"
  })));
};
export default SvgZone;